
/* injects from baggage-loader */
require('./vehicle-equity.component.html');

import angular from 'angular';

angular.module('AaApp.Opp').component('vehicleEquity', {
    templateUrl: '/app/components/deal-sheet/vehicle/vehicle-equity.component.html',
    bindings: {
        permissions: '<',
        equity: '<'
    }
});
